module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e5c63221bbefc5554a1ecbbba8a0f342.png";